"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _recharts = require("recharts");

var _isFunction = _interopRequireDefault(require("lodash/fp/isFunction"));

var _Legend = _interopRequireDefault(require("./Legend"));

var _chartHelper = require("./chartHelper");

var _excluded = ["width", "height", "data", "dataKey", "startAngle", "endAngle", "innerRadius", "outerRadius", "clockWise", "legend", "textOptions", "radialBarOptions", "showBarLabel", "cornerRadius", "background", "range", "tooltip"],
    _excluded2 = ["text", "size", "weight", "color"];

var RadialBarChart = function RadialBarChart(props) {
  var width = props.width,
      height = props.height,
      data = props.data,
      dataKey = props.dataKey,
      startAngle = props.startAngle,
      endAngle = props.endAngle,
      innerRadius = props.innerRadius,
      outerRadius = props.outerRadius,
      clockWise = props.clockWise,
      legend = props.legend,
      textOptions = props.textOptions,
      radialBarOptions = props.radialBarOptions,
      showBarLabel = props.showBarLabel,
      cornerRadius = props.cornerRadius,
      background = props.background,
      range = props.range,
      tooltip = props.tooltip,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded);

  var _ref = textOptions || {},
      text = _ref.text,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '500%' : _ref$size,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? 'normal' : _ref$weight,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'gray-darkest' : _ref$color,
      remainingTextOptions = (0, _objectWithoutProperties2.default)(_ref, _excluded2);

  var textStyle = {
    fontSize: size,
    fontWeight: weight,
    fill: color && (0, _chartHelper.getColor)(color)
  };
  return /*#__PURE__*/_react.default.createElement(_recharts.ResponsiveContainer, {
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/_react.default.createElement(_recharts.RadialBarChart, (0, _extends2.default)({
    width: width,
    height: height,
    data: data,
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    startAngle: startAngle,
    endAngle: endAngle
  }, remainingProps), /*#__PURE__*/_react.default.createElement(_recharts.RadialBar, (0, _extends2.default)({
    label: showBarLabel && {
      fill: '#666',
      position: 'insideStart'
    },
    background: background,
    clockWise: clockWise,
    dataKey: dataKey,
    cornerRadius: cornerRadius
  }, radialBarOptions), data.map(function (entry, index) {
    var cellColor = (0, _chartHelper.getColor)(entry.color) || (0, _chartHelper.getFromDefaultColors)(index);
    return /*#__PURE__*/_react.default.createElement(_recharts.Cell, {
      key: "cell-".concat(index),
      fill: (0, _isFunction.default)(color) ? color(entry, index) : cellColor
    });
  })), range && /*#__PURE__*/_react.default.createElement(_recharts.PolarAngleAxis, {
    type: "number",
    domain: range,
    angleAxisId: 0,
    tick: false
  }), textOptions && /*#__PURE__*/_react.default.createElement("text", (0, _extends2.default)({
    x: width / 2,
    y: height / 2,
    textAnchor: "middle",
    dominantBaseline: "middle",
    className: "radialbarchart-text",
    style: textStyle
  }, remainingTextOptions), text), legend && /*#__PURE__*/_react.default.createElement(_recharts.Legend, (0, _extends2.default)({
    formatter: function formatter(value, _) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "text-color-darker"
      }, value);
    }
  }, legend.props)), tooltip && /*#__PURE__*/_react.default.createElement(_recharts.Tooltip, {
    cursor: {
      fill: _chartHelper.CURSOR_BACKGROUND_COLOR
    }
  })));
};

RadialBarChart.defaultProps = {
  width: 400,
  height: 200,
  data: [],
  dataKey: 'value',
  startAngle: 180,
  endAngle: 0,
  innerRadius: '30%',
  outerRadius: '100%',
  clockWise: true,
  legend: /*#__PURE__*/_react.default.createElement(_Legend.default, null),
  // textOptions,
  // radialBarOptions,
  showBarLabel: false,
  cornerRadius: 30,
  background: true,
  // range,
  tooltip: false
};
var _default = RadialBarChart;
exports.default = _default;